import type { ApolloError } from '@apollo/client';
import LoginLink from '../../components/UI/LoginLink';
import { CONSTANTS } from '../../constants';
import { apiRoutes } from '../../constants/api-routes.constants';

const userWithThatEmailAlreadyExists =
  CONSTANTS.ErrorMessages.ALREADY_EXISTS.A_USER_WITH_THAT_EMAIL;

interface ErrorBlockProps {
  error: ApolloError;
}

export default function ErrorBlock(props: ErrorBlockProps) {
  const { error } = props;
  //const router = useRouter();
  // router.push(`${apiRoutes.LOGIN}`)

  return (
    <div role="alert">
      {error.message === userWithThatEmailAlreadyExists && (
        <LoginLink error route={apiRoutes.LOGIN} text={error.message} />
      )}
    </div>
  );
}
